import { render } from "./Saruman-ModeloOSIView.vue?vue&type=template&id=64e7401b&scoped=true"
import script from "./Saruman-ModeloOSIView.vue?vue&type=script&lang=js"
export * from "./Saruman-ModeloOSIView.vue?vue&type=script&lang=js"

import "./Saruman-ModeloOSIView.vue?vue&type=style&index=0&id=64e7401b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e7401b"]])

export default __exports__